import { jsx as _jsx } from "react/jsx-runtime";
import { Button as Btn } from '@delab-team/de-ui';
import s from './button.module.scss';
export const Button = ({ onClick, loading, children, disabled, className, ...rest }) => (_jsx(Btn, { className: `${s.button} ${className}`, disabled: disabled, loading: loading, onClick: onClick, ...rest, children: children }));
